export var NODE_TYPE = {
  REGULAR: 1,
  INHERITED: 2
};